import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M13.487 8.853a.51.51 0 1 1 1.021 0v5.619a.51.51 0 0 1-.51.51H2.757a.51.51 0 0 1-.51-.51V3.234a.51.51 0 0 1 .51-.511h5.62a.51.51 0 0 1 0 1.021H3.27v10.217h10.217z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m7.707 9.527.843-.12 5.178-5.178a.511.511 0 1 0-.722-.722L7.827 8.684zm6.744-6.743a1.533 1.533 0 0 1 0 2.168l-5.298 5.297a.5.5 0 0 1-.289.145l-1.686.241a.512.512 0 0 1-.578-.578l.241-1.686a.5.5 0 0 1 .144-.289l5.299-5.297a1.533 1.533 0 0 1 2.166 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }